import { render, staticRenderFns } from "./TasksCRM.vue?vue&type=template&id=668fd0ae&scoped=true"
import script from "./TasksCRM.vue?vue&type=script&lang=js"
export * from "./TasksCRM.vue?vue&type=script&lang=js"
import style0 from "./TasksCRM.vue?vue&type=style&index=0&id=668fd0ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668fd0ae",
  null
  
)

export default component.exports